export default "__VITE_ASSET__4HXNxkP6__"